const trackAnalyticEvent = (eventData, response) => {
  if (!response.ok) {
    return response;
  }
  response.clone().json().then((data) => {
      window.dataLayer = window.dataLayer || [];
      eventData = {
        ...eventData,
        language: window.Shopify?.locale ?? navigator.language,
        screen_resolution: window.innerWidth + "x" + window.innerHeight
    };
      window.dataLayer.push(eventData);
    });
};

const { fetch: originalFetch } = window;

/** Extending window fetch function */
window.fetch = async (...args) => {
  let [resource, config] = args;
  let response = await originalFetch(resource, config);
  if (typeof resource !== "string") {
    return response;
  }

  const body = config?.body && typeof config.body === 'string' ? JSON.parse(config.body) : {}, keys = Object.keys(body);

  if (resource.search("apps/service/shopify/create-customer") > 0) {    
    const isNewLetter = keys.length === 3 && keys.includes("email") && keys.includes("firstName") && keys.includes("postcode");

    if (isNewLetter) {
      trackAnalyticEvent(
        {
          event: "newsletterSubmit",
          eventCategory: "Newsletter",
          eventAction: "Submit",
          eventLabel: "Subscribe",
        },
        response
      );
    }

    trackAnalyticEvent(
      {
        event: "customerRegister",
        eventCategory: "CustomerRegister",
        eventAction: "Submit",
        eventLabel: "Customer Register"
      },
      response
    );
  }

  if (typeof body.type !== 'undefined' && body.type === 'product_enquiry' ) {
    trackAnalyticEvent(
      {
        event: "enquirySubmit",
        eventCategory: "Enquiry",
        eventAction: "Submit",
        eventLabel: "Enquiry Submit",
      },
      response
    );
  }

  return response;
};